/**
 * List of names of icons which should contain additional directional animations
 * to the right during cretain button user interactions.
 *
 * This is used in hover and active states of `Button` and `ListItem` components.
 */
export const iconsWithRightDirection = ['ChevronRight', 'ArrowRight'];
/**
 * Determines whether the given icon should have additional directional
 * animation effects.
 *
 * @returns `true` if the icon should be shifted right on interaction.
 */
export function isIconRightDirectional(iconName) {
    return iconName !== undefined && iconsWithRightDirection.includes(iconName);
}
